import {
	IonButtons,
	IonHeader,
	IonIcon,
	IonPage,
	IonTitle,
	IonToolbar,
	useIonRouter,
} from "@ionic/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/Global/Button";
import { Content } from "@/components/Global/Content";
import { Toolbar } from "@/components/Global/Toolbar";
import { ChooseCoreValuesWidget } from "@/components/Widgets/ChooseCoreValues";
import { CoreValuesWidget } from "@/components/Widgets/CoreValues";
import { FriendCheckWidget } from "@/components/Widgets/FriendCheck";
import { PerfectDayWidget } from "@/components/Widgets/PerfectDay";
import { RefineCoreValuesWidget } from "@/components/Widgets/RefineCoreValues";
import { ReflectionWidget } from "@/components/Widgets/Reflection";
import { ShareManifestWidget } from "@/components/Widgets/ShareManifest";
import { YourMissionWidget } from "@/components/Widgets/YourMission";
import { useReflection } from "@/lib/hooks/useReflection";
import { cog6ToothIcon } from "@/lib/icons/@heroicons/react/24/outline";
import { useMyData } from "@/lib/query/functions/user/data";
import { useMe } from "@/lib/query/functions/user/me";
import { useMyProgression } from "@/lib/query/functions/user/progression";
import { Routes } from "@/lib/router";
import { useSelectorModalStore } from "@/lib/store/modal";

export function Dashboard() {
	const { t } = useTranslation();
	const [me] = useMe();
	const [myData] = useMyData();
	const [progression, status] = useMyProgression();
	const router = useIonRouter();
	const { isLoading: reflectionIsLoading, service: reflectionService } = useReflection();
	const presentModal = useSelectorModalStore.use.present();

	useEffect(() => {
		if (
			progression.reflection === "NOT_STARTED" &&
			status.status === "success" &&
			!reflectionIsLoading &&
			!myData.modal.appExplainer.seen
		) {
			presentModal("appExplainer", {
				onCompleted: () => {
					router.push(reflectionService.router.dashboard(progression, myData), "forward");
				},
			});
		}
	}, [progression.reflection, reflectionIsLoading, myData.modal.appExplainer.seen]);

	return (
		<IonPage>
			<IonHeader>
				<Toolbar className="ion-p-2 plt-desktop:sm:ion-px-[max(calc(calc(100vw-640px)/2),--spacing(4))]">
					<IonTitle data-mask-text className="ion-text-brown-700 text-lg font-bold">
						{t("dashboard.title", { name: me?.name })}
					</IonTitle>

					<IonButtons collapse slot="primary">
						<Button
							data-attr="page.app.dashboard.settings"
							routerLink={Routes.Settings()}
							routerDirection="forward"
							size="header"
							variant="header"
						>
							<IonIcon slot="icon-only" icon={cog6ToothIcon} className="size-5" />
						</Button>
					</IonButtons>
				</Toolbar>
			</IonHeader>
			<Content className="part-scroll:gap-8">
				<IonHeader collapse="condense" className="-mt-(--padding-top)">
					<IonToolbar className="ion-px-0">
						<IonTitle
							data-mask-text
							className="ion-text-brown-700 p-0 pr-12 text-start text-3xl font-bold"
						>
							{t("dashboard.title", { name: me?.name })}
						</IonTitle>

						<IonButtons collapse slot="primary">
							<Button
								data-attr="page.app.dashboard.settings"
								routerLink={Routes.Settings()}
								routerDirection="forward"
								size="header"
								variant="header"
							>
								<IonIcon icon={cog6ToothIcon} className="size-5" />
							</Button>
						</IonButtons>
					</IonToolbar>
				</IonHeader>

				<div className="space-y-4">
					<CoreValuesWidget />

					<ReflectionWidget />
					<FriendCheckWidget />
					<ChooseCoreValuesWidget />

					<RefineCoreValuesWidget />
					<PerfectDayWidget />
					<YourMissionWidget />
					<ShareManifestWidget />
				</div>
			</Content>
		</IonPage>
	);
}
